var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 48,
    height: 48,
    fill: "#0F90FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4444 13H32.5556C33.2039 13 33.8256 13.2529 34.284 13.7029C34.7425 14.153 35 14.7635 35 15.4V31C35 31.6365 34.7425 32.247 34.284 32.6971C33.8256 33.1471 33.2039 33.4 32.5556 33.4H27.6667L24 37L20.3333 33.4H15.4444C14.7961 33.4 14.1744 33.1471 13.716 32.6971C13.2575 32.247 13 31.6365 13 31V15.4C13 14.7635 13.2575 14.153 13.716 13.7029C14.1744 13.2529 14.7961 13 15.4444 13ZM27.6667 20.2C27.6667 18.1264 26.1108 16.6 24 16.6C21.8904 16.6 20.3333 18.1264 20.3333 20.2C20.3333 22.2736 21.8904 23.8 24 23.8C26.1108 23.8 27.6667 22.2736 27.6667 20.2ZM24 26.2001C21.1559 26.2001 18.7872 27.7325 18.1052 29.8001H29.8948C29.214 27.7325 26.8441 26.2001 24 26.2001Z",
    fill: "#0F90FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.1b434a1c80f17b279bbc4f981a24912f.svg";
export { ForwardRef as ReactComponent };